import { render, staticRenderFns } from "./TarjetaCredito.vue?vue&type=template&id=5a95b512"
import script from "./TarjetaCredito.vue?vue&type=script&lang=js"
export * from "./TarjetaCredito.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports